import React, { useMemo, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { DefaultCheckBox, Table } from 'src/components';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { SubcategoryFolderIcon, SubcategoryFolderIconOpen } from 'src/Icons';
import { columns } from 'src/screens/services/ServicesScreen.data';
import { openDrawer } from 'src/store/reducers/drawerSlice';
import { setSelectedRow } from 'src/store/reducers/tableSlice';

export const CollapsibleSubCategoryRow = ({
  services,
  title,
  checkedSubCategory,
  onServiceCheckChange,
  withoutIcon = false,
  withSelection = false,
  collapsible = true,
  accordeonSummarySx = {},
  accordeonSummaryTitleSx = {},
  accordeonDetailsSx = {},
}: any) => {

  const dispatch = useAppDispatch();

  const [isAccordeonOpened, setIsAccordeonOpened] = useState(true);

  const handleChangeCollapse = () => {
    if (collapsible) {
      setIsAccordeonOpened(!isAccordeonOpened);
    }
  }

  const onRowClick = (params: any) => {
    dispatch(setSelectedRow(params.row));
    dispatch(openDrawer());
  };

  const rows = useMemo(() => {
    return (
      withSelection ? services.map((service: any) => {
        const exists = checkedSubCategory?.services?.find((el: any) => el.id === service.id);
        const isChecked = exists ? exists.isChecked : false;

        return {
          ...service,
          isChecked,
          onCheckBoxClick: (event: any) => {
            event.stopPropagation();
            onServiceCheckChange(service);
          }
        }
      }) : services
    )
  }, [checkedSubCategory, onServiceCheckChange, services, withSelection]);

  return (
    <Accordion
      expanded={isAccordeonOpened}
      onChange={handleChangeCollapse}
      sx={{
        padding: 0,
        boxShadow: 0,
        width: 'fit-content',
        '&.Mui-expanded': {
          margin: '0',
        },
        '&:before': {
          opacity: 0,
        }
      }}
    >
      <AccordionSummary sx={{
        backgroundColor: '#FFF3F6',
        padding: 0,
        minHeight: '48px',
        cursor: collapsible ? 'pointer' : 'default !important',
        '&.Mui-expanded': {
          margin: '0px',
          minHeight: '48px',
        },
        '& .Mui-expanded': {
          margin: '0px !important',
        },
        ...accordeonSummarySx
      }}>
        <Box sx={{
          margin: '0px 8px',
          display: 'flex',
          alignItems: 'center',
        }}>
          {collapsible && !withoutIcon ? (
            isAccordeonOpened
              ? <SubcategoryFolderIconOpen fontSize="inherit" />
              : <SubcategoryFolderIcon fontSize="inherit" />
          ) : null}
        </Box>
        <Typography sx={{
          color: '#363636',
          textTransform: 'uppercase',
          fontSize: '14px',
          fontWeight: '500',
          ...accordeonSummaryTitleSx,
        }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{
        padding: '0px',
      }}>
        <Table
          rows={rows}
          columns={columns}
          shouldShowOnlyContent
          onRowClick={onRowClick}
        />
      </AccordionDetails>
    </Accordion>
  )
}
